export default "__VITE_ASSET__ibk5V35N__"